/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreatorDto } from './creator-dto';
import { JoinEntityDto } from './join-entity-dto';
import { MobilityDto } from './mobility-dto';
import { ProgramSessionDto } from './program-session-dto';
 /**
 *
 *
 * @export
 * @interface ProgramDto
 */
export interface ProgramDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof ProgramDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ProgramDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ProgramDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof ProgramDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof ProgramDto
     */
    title: string;

    /**
     * @type {MobilityDto}
     * @memberof ProgramDto
     */
    mobility: MobilityDto | null;

    /**
     * @type {string}
     * @memberof ProgramDto
     */
    type: ProgramDtoTypeEnum;

    /**
     * @type {boolean}
     * @memberof ProgramDto
     */
    isTemplate?: boolean;

    /**
     * @type {string}
     * @memberof ProgramDto
     */
    shared?: ProgramDtoSharedEnum;

    /**
     * @type {string}
     * @memberof ProgramDto
     */
    note?: string;

    /**
     * @type {JoinEntityDto}
     * @memberof ProgramDto
     */
    client: JoinEntityDto;

    /**
     * @type {CreatorDto}
     * @memberof ProgramDto
     */
    creator: CreatorDto;

    /**
     * @type {Array<ProgramSessionDto>}
     * @memberof ProgramDto
     */
    sessions: Array<ProgramSessionDto>;
}

/**
 * @export
 * @enum {string}
 */
export enum ProgramDtoTypeEnum {
    THERAPY = 'THERAPY',
    TRAINING = 'TRAINING'
}
/**
 * @export
 * @enum {string}
 */
export enum ProgramDtoSharedEnum {
    NONE = 'NONE',
    ORGANIZATION = 'ORGANIZATION'
}

